import { Show, useForm } from "@refinedev/antd";
import { Button, Flex, Form, Input, Select, Space, Upload } from "antd";

import { errorNotification, successNotification } from "../../../helpers";
import { AppTitle } from "../../../components";
import { LeagueStaffType, SubsectionDocType } from "../Lib";
import { useList, useNavigation } from "@refinedev/core";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import axAPI from "../../../api/axios-instance";

export const DocsCreate = () => {
  const { push } = useNavigation();

  const [fileList, setFileList] = useState<any[]>([]);
  const [fileUrl, setFileUrl] = useState<string>("");

  const { data, isLoading, refetch } = useList<SubsectionDocType[]>({
    resource: "subsectionsDocs",
    meta: {},
    dataProviderName: "subsectionsDocsDataProvider",
    ...errorNotification(),
  });

  const { formProps, saveButtonProps, form, formLoading, onFinish } =
    useForm<LeagueStaffType>({
      resource: "docs",
      action: "create",
      meta: { fileUrl: fileUrl },
      dataProviderName: "docsDataProvider",
      redirect: false,
      ...successNotification({
        successData: {
          message: "Документ добавлен",
          type: "success",
        },
        callback: () => push("/league-info/docs"),
      }),
      ...errorNotification({}),
    });

  async function uploadFile(file: File, type: string) {
    try {
      const formData = new FormData();
      formData.append("file", file, file.name);
      const result = await axAPI.post("/cms/image/upload/type", formData, {
        params: { type },
      });
      return Promise.resolve({ s3id: result.data });
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return (
    <Show
      title={<AppTitle canGoBack>Добавление документа</AppTitle>}
      breadcrumb={false}
      footerButtons={null}
      goBack={false}
      headerButtons={<></>}
    >
      <Form {...formProps} layout={"vertical"}>
        <Flex vertical>
          <Form.Item
            name={"icon"}
            style={{ maxWidth: "500px", width: "100%" }}
            rules={[
              {
                required: true,
                message: "Загрузите иконку",
              },
            ]}
          >
            <Upload
              customRequest={(e: any) => {
                uploadFile(e.file as File, "DOCUMENTS").then((res) => {
                  setFileUrl(res.s3id);
                  e.onSuccess("ok");
                });
              }}
              accept=".pdf"
              fileList={fileList}
              onChange={({ fileList }) => {
                setFileList(fileList);
                if (!fileList.length) setFileUrl("");
              }}
            >
              <Button disabled={!!fileList.length} icon={<UploadOutlined />}>
                Click to Upload
              </Button>
            </Upload>
          </Form.Item>
          <Form.Item
            name={"title"}
            label={"Название:"}
            style={{ maxWidth: "500px", width: "100%" }}
            rules={[
              {
                required: true,
                message: "Необходимо название",
              },
              {
                max: 200,
                min: 3,
                message: "Не более 200 символов и не менее 3 символов",
              },
            ]}
          >
            <Input placeholder={"Укажите название"}></Input>
          </Form.Item>
          <Form.Item
            name="sectionId"
            label={"Подраздел"}
            style={{ maxWidth: "500px", width: "100%" }}
            rules={[
              { required: true, message: "Необходимо указать подраздел" },
            ]}
          >
            <Select placeholder="Выберите раздел">
              <Select.Option key={"-30"} value={-30}>
                <span style={{ fontWeight: 500 }}>ФНЛ</span>
              </Select.Option>
              <Select.Option key={"-31"} value={-31}>
                <span style={{ fontWeight: 500 }}>РФС</span>
              </Select.Option>
              <Select.Option key={"-32"} value={-32}>
                <span style={{ fontWeight: 500 }}>PARI 1-я лига </span>
              </Select.Option>
              <Select.Option key={"-33"} value={-33}>
                <span style={{ fontWeight: 500 }}>LEON 2-я лига А</span>
              </Select.Option>
              <Select.Option key={"-34"} value={-34}>
                <span style={{ fontWeight: 500 }}> LEON 2-я лига Б</span>
              </Select.Option>
              {data?.data.map((elem: any) => (
                <Select.Option key={elem.id} value={elem.id}>
                  (
                  <span style={{ fontWeight: 600 }}>
                    {elem.parent.parentTitle}
                  </span>
                  ) {elem.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name={"ord"}
            label={"Порядок отображения в подразделе"}
            style={{ maxWidth: "500px", width: "100%" }}
            rules={[
              {
                required: true,
                message: "Необходимо указать порядок отображения в подразделе",
              },
            ]}
          >
            <Input
              placeholder={"Укажите порядок отображения в подразделе"}
              type="number"
            ></Input>
          </Form.Item>
          <Space>
            <Button type={"primary"} htmlType={"submit"} disabled={!fileUrl}>
              {"Добавить документ"}
            </Button>
          </Space>
        </Flex>
      </Form>
    </Show>
  );
};
